var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklesGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4362_17412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.920898,
    y: 0.345703,
    width: 32.3077,
    height: 32.3077,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4362_17412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8245 11.9224L24.411 8.75894L21.2476 7.34548L24.411 5.89836L25.8245 2.76855L27.2379 5.89836L30.4014 7.34548L27.2379 8.75894L25.8245 11.9224ZM25.8245 30.2301L24.411 27.1003L21.2476 25.6532L24.411 24.2397L25.8245 21.0762L27.2379 24.2397L30.4014 25.6532L27.2379 27.1003L25.8245 30.2301ZM12.8677 25.6532L10.0408 19.3599L3.74756 16.4993L10.0408 13.6387L12.8677 7.34548L15.7283 13.6387L22.0216 16.4993L15.7283 19.3599L12.8677 25.6532Z",
    fill: "#8CE0BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesGreen);
export default __webpack_public_path__ + "static/media/sparkles-green.771f2f1c616c9ab961a86b63a6ab2eeb.svg";
export { ForwardRef as ReactComponent };